module.exports = __webpack_public_path__ + "static/media/platform-up-left.c4e8e900.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/platform-up-left.svg
// module id = 11
// module chunks = 0